// Text helpers shared by anything that renders or bounds author-typed content.

/** Lines in a block of text, counting the way a person does.
 *
 * CR/CRLF are normalised first, so the same text typed into a textarea, pasted
 * from Windows, or pasted from an older Mac editor all count the same — and a
 * `\r\n` is ONE break, never two. Blank lines count, including leading and
 * trailing ones: they are lines the reader scrolls past.
 *
 * Measured on the text exactly as given — never trimmed. The changelog line
 * limit once counted a stripped value and so accepted a 401-line paste of
 * mostly blank lines; the mirror of this function on the server
 * (admin_platform.count_lines) counts the same way for the same reason.
 */
export function countLines(text) {
  return String(text || "").replace(/\r\n?/g, "\n").split("\n").length;
}
